import { useState } from "react";
import { Form } from "react-router-dom";
import ModalNew from "../../../../../components/ui/popup/Modal";
import { PopupHeader } from "../../../../../components/ui/popup/common";
import UnifiedModal from "../../../../../components/ui/popup/UnifiedModal";

function IdentityUploadModal({
  isOpen,
  onClose,
  idUrl,
  onUploadSuccess,
  onUploadError,
  uploadFunction,
}) {
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [isUploading, setIsUploading] = useState(false);

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    // Expanded validation for PDFs and Images
    const allowedTypes = ["image/jpeg", "image/png", "application/pdf"];
    if (!allowedTypes.includes(file.type)) {
      alert("Please select a JPG, PNG, or PDF file");
      return;
    }

    if (file.size > 10 * 1024 * 1024) {
      // Increased to 10MB for high-res IDs
      alert("File size must be less than 10MB");
      return;
    }

    setSelectedFile(file);

    // Only create preview for images
    if (file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => setPreviewUrl(e.target.result);
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl("/images/icons/pdf_placeholder.svg"); // Show a PDF icon if it's a doc
    }
  };

  const handleUpload = async (event) => {
    event.preventDefault();
    if (!selectedFile || !uploadFunction) return;
    setIsUploading(true);

    try {
      const result = await uploadFunction(selectedFile);
      if (result.identity || result.identity_url) {
        handleClose();
        if (onUploadSuccess)
          onUploadSuccess(result.identity || result.identity_url);
      } else {
        if (onUploadError) onUploadError("Failed to upload. Please try again.");
      }
    } catch (error) {
      if (onUploadError)
        onUploadError("Upload failed. Please check your connection.");
    } finally {
      setIsUploading(false);
    }
  };

  const handleClose = () => {
    setSelectedFile(null);
    setPreviewUrl(null);
    onClose();
  };

  if (!isOpen) return null;

  return (
    <ModalNew className="content-modal">
      <PopupHeader
        title="Upload Identity Document"
        setOpenState={handleClose}
      />
      <UnifiedModal>
        <Form onSubmit={handleUpload} className="avatar-upload-form">
          <div className="modal-content">
            <div className="identity-preview-section">
              {/* Note: Use landscape styling here */}
              <div
                className="identity-card-preview-active"
                style={{
                  backgroundImage: `url(${
                    previewUrl || idUrl || "/images/icons/galery_grey_light.svg"
                  })`,
                  width: "100%",
                  height: "200px",
                }}
              ></div>
            </div>

            <div className="file-input-section">
              <input
                type="file"
                id="id-upload"
                accept="image/*,.pdf"
                onChange={handleFileSelect}
                style={{ display: "none" }}
              />
              <br></br>
              <div
                className="drag-drop-area"
                onClick={() => document.getElementById("id-upload").click()}
              >
                <div className="drag-drop-content">
                  <p>Drag & drop ID or Passport here</p>
                  <button type="button" className="cta-button secondary short">
                    Browse Files
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              className="cta-button secondary short"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="cta-button primary short"
              disabled={!selectedFile || isUploading}
            >
              {isUploading ? "Uploading..." : "Save Identity"}
            </button>
          </div>
        </Form>
      </UnifiedModal>
    </ModalNew>
  );
}

export default IdentityUploadModal;
